import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'react-flexbox-grid';
import { FormattedMessage } from 'react-intl';

import ActionButton from 'components/ActionButton';
import DocumentHeaderRow from 'routes/Documents/components/DocumentHeaderRow';
import DocumentTitle from 'routes/Documents/components/DocumentTitle';

const EditStartButton = ({ editing = false, onStartEdit }) => (
  <Row center="xs" end="sm">
    <Col xs={12} style={{ marginBottom: '1rem', marginTop: '1rem' }}>
      <ActionButton
        localeId={editing ? 'profile.save' : 'profile.edit'}
        border
        long
        secondary
        onClick={() => {
          onStartEdit();
        }}
      />
    </Col>
  </Row>
);

EditStartButton.propTypes = {
  editing: PropTypes.bool,
  onStartEdit: PropTypes.func.isRequired,
};

const ProfileHeader = ({ editing, localeId, startEdit, infoElement, allowHCPUse, infoText = '', descElement }) => (
  <DocumentHeaderRow>
    <Col xs={12} sm={7} md>
      <DocumentTitle localeId={localeId} infoElement={infoElement} />
      {infoText && (
        <Row style={{ marginTop: '0.5em' }}>
          <Col xs sm={9}>
            <p className="bold">
              <FormattedMessage id={infoText} />
            </p>
          </Col>
        </Row>
      )}
      {!editing && descElement && descElement}
    </Col>
    {!editing && (
      <Col xs={12} sm={5} md style={{ marginTop: '1rem' }}>
        {(window.__ROLE__ !== 'DOCTOR' || (allowHCPUse && allowHCPUse.indexOf('profile') > -1)) && (
          <EditStartButton editing={false} onStartEdit={startEdit} />
        )}
      </Col>
    )}
    {editing && (
      <Col xs={12} sm={5} md style={{ marginTop: '1rem' }}>
        <EditStartButton editing onStartEdit={startEdit} />
      </Col>
    )}
  </DocumentHeaderRow>
);

ProfileHeader.propTypes = {
  localeId: PropTypes.string.isRequired,
  infoText: PropTypes.string,
  descElement: PropTypes.node,
  allowHCPUse: PropTypes.array,
  infoElement: PropTypes.node,
  startEdit: PropTypes.func.isRequired,
  editing: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]).isRequired,
};

export default ProfileHeader;
